<template>
  <div>
    <div v-show="isNotInApp&&downloadShow" :class="isNeedCloseIn390 ? 'head1':'head'">
        <headerNav :header-title="webName" :show-sort="showSort" @yinYang="yinYang" />
    </div>
    <div ref="swipe" class="topSweipe">
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item v-for="(item, index) in imgList" :key="index">
          <img :src="item.h5_img" alt style="object-fit: cover;" @click="goSpecial(item)">
        </van-swipe-item>
      </van-swipe>
    </div>
    <div v-show="zblist.length>0" class="zhibo">
      <p class="my_curriculum_border"></p>
      <b style="font-size: 14px">直播专区</b>
      <div class="zhiboRight" @click="showAllLive">
        <span class="rightAll" style="font-size: 14px">全部直播</span>
        <img class="arrow" src="@/assets/more.png" alt="">
      </div>
    </div>
    <div v-show="zblist.length>0" class="zongjie">
      <div class="xiao_zbs">
        <ul class="main_title" :class="zblist.length===1?'main_title_width_dengyu_1':'main_title_width'">
          <li v-for="(val, key) in zblist" :key="key" class="morelive_item" :class="zblist.length===1 ? 'morelive_item_width_dengyu_1': zblist.length-1===key ? 'morelive_item_width_last':'morelive_item_width'">
            <a href="javascript:void(0);" class="live_item" :class="zblist.length===1 ? 'morelive_item_width_dengyu_1':'morelive_item_width'" @click="liveTo(val)">
              <div class="live_left">
                <img :src="val.teacher_avatar">
                <span class="teacher_name">{{ val.teacher_name }}</span>
              </div>
              <div class="live_right">
                <div class="div_content">
                  <p class="more-title">{{ val.live_name }}</p>
                  <p class="sub_title">{{ val.lesson_name }}</p>
                </div>
                <p v-if="parseInt(val.playing)===1" class="p">
                  <img src="@/assets/play.gif">
                  <span class="sp_iv" style="color: #ee2e2e">正在直播</span>
                </p>
                <p v-else class="more-yugao">
                  <img src="@/icon/zbyg.png" class="imgsnz">
                  <span class="sp_iv">直播预告&nbsp;&nbsp;{{ val.start_time_m }}</span>
                </p>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div v-show="classify_list.length>0" class="recommend">
      <p class="my_curriculum_border"></p>
      <b style="font-size: 14px">推荐专题</b>
      <div class="zhiboRight" @click="showAllTopic">
        <span class="rightAll" style="font-size: 14px">全部专题</span>
        <img class="arrow" src="@/assets/more.png" alt="">
      </div>
      <div class="topic_box">
        <div class="main_box">
          <div v-for="(item,index ) in classify_list" :key="index" class="topic_item">
            <img class="thumb" :src="item.banner" alt="" @click="showOneTopic(item)">
            <div class="collect">
              {{ getNum(item.count) }}
              <span class="text">收藏</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="lessonList">
      <van-list v-show="isShow" v-model="loading" :finished="finished" finished-text="没有更多了" @load="getList">
        <div v-for="(item,index) in list" :key="index" class="lessonLists" @click="goLessonDetail(item)">
          <div v-if="item.price==0" class="tip">限时免费</div>
          <div v-else-if="item.discount_rate==0" class="tip">VIP免费</div>
          <van-image class="lessonImg" fit="cover" :src="item.logo" />
          <p class="lessTit">{{ item.title }}</p>
          <div class="lessonInfo">
            <van-icon name="friends-o" color="#A3A3A3" size="18" />
            <p class="less_p">{{ item.student?item.student:0 }}人学习</p>
            <van-icon style="padding-left: 9px;margin-top: 1px" size="17" name="clock-o" color="#A3A3A3 " />
            <p class="less_p" style="padding-left: 2px;">{{ item.time?item.time:0 }}分钟</p>
          </div>
        </div>
      </van-list>
    </div>
    <footerNav active="/svip"></footerNav>
    <!-- <commonBottom v-show="isNotInApp"></commonBottom> -->
  </div>
</template>

<script>
// Android 调用 js初始化
function connectWebViewJavascriptBridge(callback) {
  if (window.WebViewJavascriptBridge) {
    // eslint-disable-next-line no-undef
    callback(WebViewJavascriptBridge)
  } else {
    document.addEventListener(
      'WebViewJavascriptBridgeReady'
      , function() {
        // eslint-disable-next-line no-undef
        callback(WebViewJavascriptBridge)
      },
      false
    )
  }
}
// 注册回调函数，第一次连接时调用 初始化函数
connectWebViewJavascriptBridge(function(bridge) {
  // JS方法名
  bridge.registerHandler('appCacheFid', function(data, responseCallback) {
    responseCallback('VIP已执行')
    const json = JSON.parse(data)
    window.appCacheFid(json.fid, json.fname)
  })
})

import { get_imgs, get_list, get_liveList } from '@/api/vip.js'
import { getVipSpecial } from '@/api/vipList'
// import commonBottom from '@/components/homeBottom.vue'
// import headertop from '@/components/homeTop.vue'
import tool from '@/utils/tools.js'
import Cookie from 'js-cookie'
import { getRowSeo } from '@/api/edu.js'
import { getUserFid } from '@/api/common.js'
import WechatState from '@/utils/isWechatState.js'
import Cookies from 'js-cookie'
export default {
  components: {
    // commonBottom,
    // headertop
  },
  data() {
    return {
      imgList: [],
      list: [],
      zblist: [],
      isNotInApp: true,
      fid: Cookies.get('webSpecialty_id') || '',
      loading: false,
      finished: false,
      isShow: true,
      page: 1,
      limit: 10,
      downloadShow: true,
      Before_scollH: 0,
      query: {
        category_id: '',
        type: 1,
        page: 1,
        limit: 4
      },
      classify_list: [],
      webName: Cookies.get('webName') || '',
      showSort: Cookies.get('webName') ? '0' : '1',
      // 其他机构嵌套他们app的，Eg：390，需要给个关闭按钮,调用他们自己的方法
      isNeedCloseIn390: false
    }
  },
  mounted() {
    const need = tool.checkLocationAgencyIdInApp('390')
    if(need){
      this.isNeedCloseIn390 = true
    }
    this.getSeo()
    this.checkApp()
    // 挂载函数，方便APP调用
    if (tool.isInApp()) {
      window.appCacheFid = this.appCacheFid
    }
    this.getImgs()
    if (this.fid === '') {
      // 无fid 先请求一个接口
      console.log('fid 不存在')
      this.getUserDefaultFid()
    } else {
      this.beforeGetList()
    }
    this.get_vipliveList()
    this.getVipSpecialFun()

    // 头部下拉隐藏,上拉显示
    this.$nextTick(() => {
      const _this = this
      window.onscroll = function() {
        const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
        if (scrollTop <= 0) { // 处理回弹
          _this.downloadShow = true
        } else {
          const differH = scrollTop - _this.Before_scollH
          if (differH == 0) {
            _this.downloadShow = true
          }
          const scollType = differH > 0 ? 'down' : 'up'
          _this.Before_scollH = scrollTop
          if (scollType == 'down') {
            _this.downloadShow = false
          } else if (scollType == 'up') {
            _this.downloadShow = true
          }
        }
      }
    })
  },
  methods: {
    goSpecial(item){
      location.href = item.url
    },
     yinYang(value) {
      this.webName = value.className
      this.fid = value.secondId
      console.log(value)
      this.beforeGetList()
      this.getList()
    },
    // 获取推荐专题
    getVipSpecialFun() {
      getVipSpecial(this.query).then((res) => {
        if (res.errNo == 0) {
          this.classify_list = res.result.list
        }
      })
    },
    getSeo() {
      console.log(123)
      var params = {
        type: 3
      }
      getRowSeo(params).then(res => {
        console.log(res.result, 'res.resultres.result')
        // 设置title标题
        const my_title = document.getElementsByTagName('title')[0]
        my_title.innerHTML = res.result.result.title
        // 设置关键词
        const my_keys = document.getElementsByName('keywords')[0]
        my_keys.content = res.result.result.words
        // 设置描述
        const my_description = document.getElementsByName('description')[0]
        my_description.content = res.result.result.description
      })
    },
    // APP调用 存储id
    appCacheFid(fid, name) {
      const ffid = Number(fid)
      if (ffid > 0) {
        Cookie.set('fid', ffid)
        this.fid = fid
        this.beforeGetList()
        this.getList()
      }
      if (name && name.length > 0) {
        Cookie.set('Fname', name)
      }
    },
    checkApp() {
      if (tool.isInApp()) {
        this.isNotInApp = false
      }
    },
    // selectFid(fid) {
    //   console.log('fid:' + fid)
    //   this.fid = fid
    //   this.beforeGetList()
    //   this.getList()
    // },
    // 获取用户后台分配fid
    getUserDefaultFid() {
      getUserFid().then(res => {
        const result = res.result ? res.result : {}
        const fid = result.userid
        this.fid = fid
        this.beforeGetList()
        Cookie.set('fid', fid)
      })
    },
    // 获取直播列表
    get_vipliveList() {
      var params = {
        category_id: this.fid
      }
      get_liveList(params).then(res => {
        this.zblist = res.result.list
      })
    },
    // 跳转直播页面
    liveTo(item) {
      // 下面两行代码虽然注释，但是勿删
      // const mplogin = WechatState.checkWechatMPLogin()
      // if (!mplogin) return

      if (tool.isInApp()) {
        if (item.playing === 1) {
          // 去直播
          const livePath = 'lesson_id=' + item.lesson_id + '&live_id=' + item.id + '&wk_id=' + item.wk_id
          if (tool.isInIosApp()) {
            window.webkit.messageHandlers.vue_openLive.postMessage(livePath)
          } else {
            window.WebViewJavascriptBridge.callHandler(
              'vue_openLive'
              , livePath
              , function(responseData) {
                // android 返参数接受
              }
            )
          }
        } else {
          // 课程详情
          var url = item.view_url
          url = 'https://www.zhulong.com' + url
          if (tool.isInIosApp()) {
            console.log(url)
            window.webkit.messageHandlers.vue_openLesson.postMessage(url)
          } else {
            window.WebViewJavascriptBridge.callHandler(
              'vue_openLesson'
              , url
              , function(responseData) {
                // android 返参数接受
              }
            )
          }
        }
      } else {
        // window.location.href = item.url
        if(item.playing){
          this.$router.push({
            path:'/live',
            query:{
              lesson_id:item.lesson_id,
              live_id:item.id
            }
          })
        }else{
          this.$router.push({
            path:'/home',
            query:{
              lesson_id:item.lesson_id
            }
          })
        }
      }
    },
    beforeGetList() {
      this.page = 1
      this.list = []
      this.loading = false
      this.finished = false
      this.isShow = true
    },
    // 获取列表
    getList() {
      var params = {
        category_id: this.fid,
        page: this.page,
        limit: this.limit
      }
      get_list(params).then(res => {
        this.loading = false
        const result = res.result ? res.result : {}
        const arr = result.list ? result.list : []
        if (arr.length < this.limit) {
          // 么有了
          this.finished = true
        } else {
          // 还有
          this.finished = false
          this.page++
        }
        this.list = this.list.concat(arr)
      }).catch(err => {
        this.loading = false
      })
    },
    // 轮播图跳转课程详情
    goLessonDetail(item) {
      // 下面两行代码虽然注释，但是勿删
      // const mplogin = WechatState.checkWechatMPLogin()
      // if (!mplogin) return

      if (tool.isInApp()) {
        if (tool.isInIosApp()) {
          window.webkit.messageHandlers.vue_openUrl.postMessage(url)
        } else {
          window.WebViewJavascriptBridge.callHandler('vue_openUrl', url,
            function(responseData) {
              // android 返参数接受
            }
          )
        }
      } else {
        this.$router.push({
          path:'/home',
          query:{
            lesson_id:item.id
          }
        })
      }
    },
    getImgs() {
      get_imgs().then(res => {
        if (res.errNo === 0) {
          const result = res.result || []
          this.imgList = result
        }
      })
    },
    // 全部直播
    showAllLive() {
      // 下面两行代码虽然注释，但是勿删
      // const mplogin = WechatState.checkWechatMPLogin()
      // if (!mplogin) return

      const host = window.location.host
      const scheme = window.location.protocol
      const url = scheme + '//' + host + '/shouye/zhibo' + '?vip=1'
      console.log(url)
      if (tool.isInApp()) {
        if (tool.isInIosApp()) {
          window.webkit.messageHandlers.vue_openUrl.postMessage(url)
        } else {
          window.WebViewJavascriptBridge.callHandler('vue_openUrl', url,
            function(responseData) {
              // android 返参数接受
            }
          )
        }
      } else {
        this.$router.push({
          path:'/liveList',
          query:{
            vip:1
          }
        })
      }
    },
    // 全部专题
    showAllTopic() {
      // 先处理 小程序
      // const mplogin = WechatState.checkWechatMPLogin()
      // if (!mplogin) return

      // 再处理 APP  h5
      const host = window.location.host
      const scheme = window.location.protocol
      const url = scheme + '//' + host + '/svip/allProjects'
      console.log(url)
      if (tool.isInApp()) {
        if (tool.isInIosApp()) {
          window.webkit.messageHandlers.vue_openUrl.postMessage(url)
        } else {
          window.WebViewJavascriptBridge.callHandler('vue_openUrl', url,
            function(responseData) {
              // android 返参数接受
            }
          )
        }
      } else {
        this.$router.push({
          path: 'allProjects'
        })
      }
    },
    // 单个专题
    showOneTopic(val) {
      // 先处理 小程序
      // 下面两行代码虽然注释，但是勿删
      // const mplogin = WechatState.checkWechatMPLogin()
      // if (!mplogin) return

      // // 再处理 APP  h5
      // const url = val.url
      // console.log(url)
      // if (tool.isInApp()) {
      //   if (tool.isInIosApp()) {
      //     window.webkit.messageHandlers.vue_openUrl.postMessage(url)
      //   } else {
      //     window.WebViewJavascriptBridge.callHandler('vue_openUrl', url,
      //       function(responseData) {
      //         // android 返参数接受
      //       }
      //     )
      //   }
      // } else {
      //   window.location.href = url
      // }
      window.location.href = '/svip/vipSpecial?id='+val.id
    },
    getNum(num) {
      if (num < 1000) {
        return num
      } else if (num >= 1000 && num < 10000) {
        return parseInt((num / 1000 * 10)) / 10 + 'k'
      } else if (num >= 10000) {
        return parseInt((num / 10000 * 10)) / 10 + 'w'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.imgListimg {
  width: 100%;
  height: 100%;
}

.lessonList {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 130px;
  justify-content: space-between;
  .lessonLists {
    position: relative;
    float: left;
    width: calc((100% - 60px) / 2);
    height: 360px;
    margin-top: 20px;
    margin-bottom: 20px;
    margin-left: 20px;
    .tip {
      position: absolute;
      z-index: 1;
      width: 134px;
      height: 52px;
      line-height: 52px;
      text-align: center;
      border-radius: 0 0px 10px 0;
      font-size: 30px;
      color: #866335;
      background-image: linear-gradient(to right, #fceacc, #f6d19d);
    }
    .lessonImg {
      width: 100%;
      height: 240px;
      object-fit: cover;
    }
    .less_p {
      font-size: 24px;
      color: #999;
    }
    .lessTit {
      line-height: 60px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 300px;
      font-size: 28px;
      padding-left: 10px;
    }
  }
  .lessonInfo {
    display: flex;
    p {
      font-size: 12px;
    }
  }
}
.liveList {
  overflow-x: scroll;
  display: flex;
  padding-right: 20px;
  border-bottom: 15px solid #f2f2f2;
  height: 205px;
}
.liveTime {
  display: flex;
  margin-left: 90px;
  img {
    width: 30px;
    height: 30px;
  }
  p {
    padding: 0 0px 0 15px;
  }
}
dl img {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: chocolate;
}
dl {
  display: flex;
  margin: 15px;
  p {
    width: 240px;
    padding: 5px 0 0 15px;
    line-height: 42px;
  }
}
.liveLists {
  margin-left: 20px;
  flex-shrink: 0;
  overflow: hidden;
  width: 50%;
  height: 180px;
  background: #f2f2f2;
  border-radius: 15px;
}
.moreP {
  color: #999;
}
.viptit {
  color: #444;
  border-left: 5px solid #ee2e2e;
  margin-left: 15px;
  padding-left: 10px;
}
.vipTitle {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .more {
    display: flex;
    align-items: center;
    height: 60px;
    img {
      width: 15px;
      height: 26px;
      margin: 0 15px 0 10px;
    }
  }
}
.topSweipe {
  // margin-top: 90px;
}
// .my-swipe .van-swipe-item {
//   height: 376px;
//   color: #fff;
//   font-size: 20px;
//   line-height: 350px;
//   text-align: center;
//   /deep/.van-image__img{
//      width: 100%;
//      height: 376px;
//   }
// }
.my-swipe .van-swipe-item {
  color: #fff;
  font-size: 20px;
  // line-height: 376px;
  text-align: center;
  background-color: #fff;
  height: 380px;
  // position: relative;
  // width: 100%;
  // height: 0;
  // padding-top: 100%;
  img {
    width: 100%;
    height: 376px;
    // position: absolute;
    // top: 0;
    // left: 0;
    // width: 100%;
    // height: 56.3%;
  }
}
.head1 {
  border-bottom: 1px solid #f2f2f2;
  width: 100%;
  height: 160px;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.head{
  border-bottom: 1px solid #f2f2f2;
  width: 100%;
  height: 90px;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.msgBtn {
    width: 50px;
    height: 50px;
  }
  .serch {
    width: 80%;
    height: 65px;
    background: #f2f2f2;
    border-radius: 15px;
    display: flex;
    align-items: center;
    div {
      width: 110px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      span {
        color: #ccc;
        font-size: 28px;
        padding-left: 5px;
      }
      img {
        width: 37px;
        height: 37px;
      }
    }
  }
.tieding_no_border {
  width: 92%;
  height: 237px;
  margin: 0 auto;
  display: flex;
  justify-content: space-around;
  div {
    width: 100%;
    height: 149px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 50px;
    position: relative;
  }
}
.list_i {
  width: 83px;
  height: 83px;
  background-size: 100% auto;
}
.my_curriculum_border {
  float: left;
  display: inline-block;
  width: 5px;
  height: 34px;
  background: #db403b;
  margin: 0px 0 0 30px;
}
.xiao_zbs {
  padding-left: 30px;
  height: 100%;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  margin-top: 10px;
}
.xiao1:last-child {
  margin-right: 20px !important;
}
.zongjie {
  width: 100%;
  height: 280px;
  // background: blue;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
}
.zhiboleft {
  position: absolute;
  right: 5px;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgb(153, 153, 153);
  span {
    display: inline-block;
    float: right;
    margin-right: 20px;
  }
}
.zhibo {
  width: 99%;
  height: 40px;
  margin: 0 auto;
  // background: #eee;
  margin-top: 20px;
  line-height: 40px;
  position: relative;
  b {
    margin-left: 15px;
  }
}
.recommend{
  margin: 0 auto;
  // background: #eee;
  margin-top: 20px;
  line-height: 40px;
  position: relative;
  b {
    margin-left: 15px;
  }
}
.zhiboRight {
  float: right;
  margin-right: 10px;
  justify-content: center;
  align-items: center;
  display: flex;
  .rightAll {
    line-height: 30px;
    margin-right: 10px;
  }
  .arrow {
    width: 12px;
  }
}

.p1 {
  position: absolute;
  bottom: 7px;
  font-size: 28px;
  text-align: center;
}
.tieding {
  width: 92%;
  height: 237px;
  margin: 0 auto;
  border-bottom: 1.5px solid #eee;
  display: flex;
  justify-content: space-around;
  div {
    width: 100%;
    height: 149px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 50px;
    position: relative;
  }
}
.main_title {
  display: flex;
  height: 100%;

  align-items: center;
  flex-shrink: 0;
  .morelive_item_width_dengyu_1 {
    width: 99%;
  }
  .morelive_item_width {
    width: 480px;
    margin-right: 34px;
  }
  .morelive_item_width_last {
    width: 480px;
  }
  ul:last-child {
    margin-left: 34px;
  }

  .morelive_item {
    height: 220px;
    float: left;
    position: relative;
    border-radius: 10px;
    background: #f7f7f7;
    border: 1px solid #e6e6e6;
    .live_item {
      height: 100%;
      display: flex;
      .live_left {
        padding-top: 5px;
        padding-bottom: 40px;
        margin-top: 10px;
        margin-right: 10px;
        display: flex;
        align-items: center;
        justify-content: space-around;
        flex-direction: column;
        .teacher_name {
          font-size: 24px;
          color: #999999;
        }
        & > img {
          width: 79px;
          height: 79px;
          // display: inline-block;
          overflow: hidden;
          border-radius: 50%;
          margin: 10px 23px 3px 23px;
          border: 0 solid #e6e6e6;
        }
      }
      .live_right {
        height: 184px;
        padding-top: 28px;
        padding-bottom: 10px;
        width: 66%;
        display: flex;
        position: relative;
        flex-direction: column;
        .div_content {
          width: 100%;
        }
        .p {
          display: flex;
          position: absolute;
          bottom: 0px;
          margin-bottom: 20px;
          align-items: center;
          img {
            width: 24px;
            height: 24px;
          }
        }
      }
    }

    p {
      & > img {
        width: 16px;
        vertical-align: sub;
        margin-right: 6px;
      }
    }

    .more-title {
      // height: 70px;
      // padding-top: 23px;
      font-size: 28px;
      color: #333333;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      white-space: pre-wrap;

      &:hover {
        color: #ee2e2e;
      }
    }
    .sub_title {
      font-size: 26px;
      color: #999999;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      overflow: hidden;
      margin-top: 12px;
      white-space: pre-wrap;

      // margin-bottom:20px;
    }
    .more-yugao {
      position: absolute;
      bottom: 0px;
      color: #adadad;
      margin-bottom: 20px;
      display: flex;
      align-items: center;
      font-size: 24px;
      img {
        width: 32px;
        height: 32px;
      }
    }
  }
}
/deep/.van-list {
  width: 100%;
}
.topic_box{
  width: 100%;
  display: flex;
  overflow-x: scroll;
}
.main_box{
  flex-shrink:0;
  padding: 28px;
  // display: flex;
  // flex-wrap: wrap;
  // width: 1842px;
  height: 189px;
  .topic_item{
    width: 443px;
    height: 189px;
    margin-right: 23px;
    // margin-bottom: 30px;
    position:relative;
    float: left;
    .thumb{
      width: 100%;
      height: 100%;
    }
    .collect{
      position:absolute;
      bottom:0;
      right: 0;
      background: rgba(51,51,51,0.90);
      border-radius: 12px 0px 0px 0px;
      color:#fff;
      padding: 4px 20px;
      font-size: 24px;
      .text{
        margin-left: 4px;
      }
    }
    &:nth-child(4n){
      margin-right: 0;
    }
  }
}
.clearfix:after{
  content: '';
  clear: both;
  display: block;
  height: 0;
  overflow: hidden;
  visibility: hidden;
}
</style>
